import React from 'react';
import { Tag } from '@fasstech/middle-design-system';
import { isEmpty, map } from 'ramda';

const CoverageZoneTags = ({ zones }) => {
  if (isEmpty(zones)) {
    return null;
  }

  return (
    <div className="flex flex-wrap justify-center gap-1 mb-2 text-xs text-[#313335]">
      {map(
        (zone) => (
          <Tag key={zone} label={zone} variant="neutral" />
        ),
        zones
      )}
    </div>
  );
};

export default CoverageZoneTags;
